export default __webpack_public_path__ + "static/media/BGLogo.d27bdf32.jpg";